import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import useLoading from '@hooks/useLoading'
import { confirmation, notify } from '@helpers'
import { ReactComponent as CloseIcon } from '@icons/close.svg'
import { ReactComponent as DownloadIcon } from '@icons/download.svg'
import { ReactComponent as EditIcon } from '@icons/edit.svg'
import { ReactComponent as EnvelopeIcon } from '@icons/envelope.svg'
import React, { useRef, useState } from 'react'
import { useFinishedDashboardContext } from '../../../context'

export default function Ebook() {
    const [choose, setChoose] = useState(false)
    const { salon } = useSalonManagerContext()
    const { finished } = useFinishedDashboardContext()
    const input = useRef<HTMLInputElement>()

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
        const file = e.target.files?.[0]
        if (!file) return
        
        try {
            await salon.api.ebook.store(file)
            notify("The ebook was uploaded.")
    
            if (!finished.data.ebook) {
                finished.setData(old => {
                    return { ...old, ebook: true }
                })
            }
    
            if (choose) 
                setChoose(false)
        } catch {
            input.current!.value = ''
        }
    }

    if ((finished.data.ebook && choose) || (!finished.data.ebook)) {
        return (
            <Grid gap="5px">
                <small>Ebook</small>
                <Flex gap="5px" alignItems="center">
                    <Input onChange={handleChange} id="ebook" name="ebook" type="file" ref={input} />
                    <Button type="tertiary" icon={<CloseIcon />} onClick={() => setChoose(false)} />
                </Flex>
            </Grid>
        )
    }

    const handleSend = async () => {
        const confirmed = await confirmation("Are you sure you want to send ebooks to customers?")
        if (!confirmed) return

        await salon.api.notifications.ebook()
        notify("Sending ebooks to customers...")
    }

    return (
        <Grid gap="5px">
            <small>Ebook</small>
            <Flex gap="5px" alignItems="center">
                <Button type="tertiary" icon={<EnvelopeIcon />} onClick={handleSend}>Send</Button>
                <Button type="tertiary" icon={<DownloadIcon />} to={`/api/salons/${salon.state.slug}/ebook`} element="a" target="_blank" />
                <Button type="tertiary" icon={<EditIcon />} onClick={() => setChoose(true)} />
            </Flex>
        </Grid>
    )
}